$.exitIntent('enable');

$(document).bind('exitintent', function() {
	if(!localStorage.getItem('exitIntentTriggered')) {
		localStorage.setItem('exitIntentTriggered', true);
		$('#emailSignupModal').modal('show');
	}
});

$('form.contact-form').submit( function(){
  $('p.error, p.success').remove();
  if($(this).find('input[type="email"]').val() !== ''){
    var data = $(this).serialize();
    $.ajax({  
      type: "POST",  
      url: "/contact",  
      data: data,  
      success: function() { 
        $('.contact-form').replaceWith('<p class="success w-100 text-center border border-success rounded p-3">Success! Thank-you for subscribing to my newsletter!</p>');        
      },
      error: function() {
        $('.contact-form').prepend('<p class="error w-100 text-center border border-danger rounded p-3">An error occurred. Please check your email and try again.</p>');
      }    
    }); 
  }
  else {
    $(this).prepend('<p class="error w-100 text-center border border-danger rounded p-3">Please fill in your email address.</p>');  
  }
  return false;
});

$("#add_to_cart_form").submit(function(e) {
  e.preventDefault(); 

  var form = $(this);
  var url = form.attr('action');
  
  $.ajax({
    type: "POST",
    url: url,
    data: form.serialize(),
    success: function(data)
    {
       window.location.href = "/cart";
    }
  });
});